import React from 'react';

const GradientThankYou = ({ size = '100%' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 456.531 456.531" style={{ width: size, height: 'auto' }}>
        <defs>
            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stopColor="#7670e9" />
                <stop offset="1" stopColor="#cf8eff" />
            </linearGradient>
        </defs>
        <g id="Group_22959" data-name="Group 22959" transform="translate(-1894.466 -3718.465)">
            <circle id="Ellipse_30" data-name="Ellipse 30" cx="228.265" cy="228.265" r="228.265" transform="translate(1894.466 3718.465)" opacity="0.05" fill="url(#linear-gradient)" />
            <circle id="Ellipse_31" data-name="Ellipse 31" cx="150.185" cy="150.185" r="150.185" transform="translate(1972.546 3796.546)" opacity="0.36" fill="url(#linear-gradient)" />
            <circle id="Ellipse_32" data-name="Ellipse 32" cx="111.918" cy="111.918" r="111.918" transform="translate(2010.814 3834.812)" fill="url(#linear-gradient)" />
            <circle id="Ellipse_33" data-name="Ellipse 33" cx="193.787" cy="193.787" r="193.787" transform="translate(1928.945 3752.944)" opacity="0.2" fill="url(#linear-gradient)" />
            <g id="Group_22957" data-name="Group 22957" transform="translate(2050.793 3902.558)">
                <g id="Group_22956" data-name="Group 22956" transform="translate(0 0)">
                    <path id="Path_33322" data-name="Path 33322" d="M6252.947,946.438l-38.581-50.406a8.884,8.884,0,0,1,1.656-12.453h0a8.882,8.882,0,0,1,12.452,1.655l26.845,35.071a8.882,8.882,0,0,0,13.021,1.181l72.934-66.132a8.883,8.883,0,0,1,12.548.614h0a8.883,8.883,0,0,1-.615,12.548l-87.237,79.1A8.884,8.884,0,0,1,6252.947,946.438Z" transform="translate(-6212.537 -853.053)" fill="#fff" />
                </g>
            </g>
        </g>
    </svg>
);

export default GradientThankYou;